import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import aderabhimImg from '../../assets/images/testimonial/aderabhim.png';
import somseImg from '../../assets/images/testimonial/pierre.png';
import atunImg from '../../assets/images/testimonial/atun.png'

const testimonials = [
  {
    name: 'Hon. Pierre Somse',
    title: 'Ministre de la Santé Publique et de la Prévention',
    quote: `“Augmentation de la connectivité internet grâce à des dispositifs internet portables Dispositifs portables pour la saisie des données Eau et technologies eau potable”`,
    image: somseImg,
  },
  {
    name: 'Dr. Abdelmadjid Abderahim',
    title: 'Ministre de la Santé Publique et de la Prévention',
    quote: `“Augmentation de la connectivité internet grâce à des dispositifs internet portables Dispositifs portables pour la saisie des données Eau et technologies eau potable”`,
    image: aderabhimImg,
  },
  {
    name: 'Prof. Rifat Atun',
    title: 'Ministre de la Santé Publique et de la Prévention',
    quote: `“Augmentation de la connectivité internet grâce à des dispositifs internet portables Dispositifs portables pour la saisie des données Eau et technologies eau potable”`,
    image: atunImg,
  },
  
];

const ProductTestimonial = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#ffff',
        py: 6,
        px: { xs: 2, md: 8 },
        color: '#fff',
      }}
      className="testimonialSection"
    >
      <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={40}
        slidesPerView={1}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                textAlign: 'center',
                px: 2,
              }}
            >
              <Avatar
                src={testimonial.image}
                alt={testimonial.name}
                sx={{
                  width: 100,
                  height: 100,
                  mx: 'auto',
                  mb: 2,
                  // border: '4px solid gold',
                }}
              />
              <Typography
                variant="body2"
                sx={{ fontStyle: 'italic', color: '#252525', mb: 1 , p:4 }}
              >
                {testimonial.quote}
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ color: '#A349F6', fontWeight: 'bold' }}
              >
                {testimonial.name}
              </Typography>
              <Typography variant="body2" sx={{ color: '#252525' }}>
                {testimonial.title}
              </Typography>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default ProductTestimonial;
